import "../styles/StatsGrid.css";
import { FaArrowDown, FaClock, FaChartLine } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";

export default function StatsGrid({ stats, usedToday }) {
  const getRemainingTime = (expiresAt) => {
    const now = new Date();
    const expiry = new Date(expiresAt);
    const diff = expiry - now;
    if (diff <= 0) return "Expired";
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30);
    const remainingDays = days % 30;
    return `${months} month(s) ${remainingDays} day(s)`;
  };

  return (
    <div className="stats-grid">
      <div className="stat-card green">
        <div className="icon-label">
          <div className="icon-wrapper green-bg">
            <FaArrowDown />
          </div>
          <p className="label">Daily Remaining</p>
        </div>
        <p className="value">{stats.daily_limit - usedToday}</p>
        <p className="sub">{usedToday}/{stats.daily_limit} used</p>
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill green-bar"
            style={{ width: `${(usedToday / stats.daily_limit) * 100}%` }}
          ></div>
        </div>
      </div>

      <div className="stat-card blue">
        <div className="icon-label">
          <div className="icon-wrapper blue-bg">
            <FaClock />
          </div>
          <p className="label">Remaining Time</p>
        </div>
        <p className="value">{getRemainingTime(stats.expires_at)}</p>
        <p className="sub">until {stats.expires_at}</p>
      </div>

      <div className="stat-card purple">
        <div className="icon-label">
          <div className="icon-wrapper purple-bg">
            <FiDownload />
          </div>
          <p className="label">Maximum</p>
        </div>
        <p className="value">{stats.maximum}</p>
        <p className="sub">{stats.total_downloaded}/{stats.maximum} used</p>
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill purple-bar"
            style={{
              width: `${(stats.total_downloaded / stats.maximum) * 100}%`,
            }}
          ></div>
        </div>
      </div>

      <div className="stat-card yellow">
        <div className="icon-label">
          <div className="icon-wrapper yellow-bg">
            <FaChartLine />
          </div>
          <p className="label">Total</p>
        </div>
        <p className="value">{stats.total_downloaded}</p>
        <p className="sub">All time</p>
      </div>
    </div>
  );
}
